/**
 * @module events/options/capture
 */

/**
 * @type {boolean}
 */
export default true
